/* eslint-disable no-param-reassign */
import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Button } from '@jutro/legacy/components';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useTranslator } from '@jutro/locale';
import styles from "../../../../SpecialtyPersonalStyles.module.scss"
import metadata from './PropertyDetailsComponent.metadata.json5';
import StorageFacilityExp from '../StorageFacilityExp/StorageFacilityExp';
import messages from './PropertyDetailsComponent.messages.js';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function PropertyDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('PropertyDetailsComponent');
    const { authHeader } = useAuthentication();
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const modelVM = _.get(submissionVM, pathUpdated);
    const [storageFacCodeSearchVisible, setStorageFacCodeSearchVisible] = useState(false);
    const [sfapprovalCode, updateSFapprovalCode] = useState('');
    const [approvedStorageFac, updateApprovedStorageFac] = useState('');
    const [stoFacAddress, updateStoFacAddress] = useState('');
    const [stoFacCity, updateStoFacCity] = useState('');
    const [stoFacProvince, updateStoFacProvince] = useState('');
    const [stoFacPostal, updateStoFacPostal] = useState('');
    const translator = useTranslator();
    const [emptyResultWarning, setEmptyResultWarning] = useState(false);

    modelVM.value.isValidationReq = true;
    modelVM.value.locRisk.isValidationReq = true;

    const onCell = (item, index, { id: property }) => item[property];

    const renderSelectButton = (item, index, { id: property }) => (
        <Button type='text' onClick={(e) => onActionClick(item, index)}>
            Select
        </Button>
    );

    const loadData = ({ pageSize, page }) => {
        const paginationParams = {
            fromPage: page,
            pageSize
        };

        return searchStorageFacilityCode(paginationParams);
    };

    const searchStorageFacilityCode = async (paginationParams) => {
        const storageFacClassCodes = {
            sfstorageFacilityApprovalCode: sfapprovalCode,
            approvedStorageFacilities: approvedStorageFac,
            address: stoFacAddress,
            city: stoFacCity,
            province: stoFacProvince,
            postal: stoFacPostal

        };

        if (!paginationParams) {
            paginationParams = {
                fromPage: 0,
                pageSize: 10
            };
        }

        const reqParam = {
            storageFacClassCodes,
            pageNumber: paginationParams.fromPage,
            pageSize: paginationParams.pageSize
        }

        try {
            const response = await LoadSaveService.getProInStoStorageFacClassCodes_Ext(reqParam, authHeader);

            setStorageFacCodeSearchVisible(true);
            setEmptyResultWarning(false);

            if (response != null) {
                return {
                    rows: response.storageFacClassCodes,
                    numberOfRows: response.maxNumberOfResults
                };

            }

            setEmptyResultWarning(true)

            return {
                rows: [],
                numberOfRows: 0
            };
        } catch (ex) {
            setEmptyResultWarning(true)
        }


    };

    const clearSearchTexts = () => {
        updateSFapprovalCode('');
        updateApprovedStorageFac('');
        updateStoFacAddress('');
        updateStoFacCity('');
        updateStoFacProvince('');
        updateStoFacPostal('')
    }

    const cancelSearch = () => {
        setStorageFacCodeSearchVisible(false);
    }

    const openSearchPanel = () => {
        setStorageFacCodeSearchVisible(true);
    }

    const clearIndustryDescription = () => {
        _.set(modelVM, 'locRisk.stoSfCode.value', '')
        _.set(modelVM, 'locRisk.stoFacFie.value', '')
        _.set(modelVM, 'locRisk.stoAddFie.value', '')
        _.set(modelVM, 'locRisk.stoCitFie.value', '')
        _.set(modelVM, 'locRisk.stoProvinceCode.value', '')
        _.set(modelVM, 'locRisk.stoProvince.value', '')
        _.set(modelVM, 'locRisk.stoPosCodFie.value', '')
        updateWizardData(submissionVM);
    }

    const mapCodeToProvince = useCallback((code) => {
        let province = ''

        switch (code) {

            case 'AB':
                province = 'Alberta'
                break;

            case 'BC':
                province = 'BriCol'
                break;

            case 'ON':
                province = 'Ontario'
                break;

            case 'NS':
                province = 'NovSco'
                break;

            case 'MB':
                province = 'Man'
                break;

            case 'SK':
                province = 'Sas'
                break;
            default:
                province = ''
        }

        return province
    }, [])

    const mapCodeToProvinceCode = useCallback((province) => {
        let code = ''

        switch (province) {

            case 'Alberta':
                province = 'AB'
                break;

            case 'BriCol':
                code = 'BC'
                break;

            case 'Ontario':
                code = 'ON'
                break;

            case 'NovSco':
                code = 'NS'
                break;

            case 'Man':
                code = 'MB'
                break;

            case 'Sas':
                code = 'SK'
                break;
            default:
                code = ''
        }

        return code
    }, [])

    const onActionClick = useCallback((object) => {
        _.set(modelVM, 'locRisk.stoSfCode.value', object.sfstorageFacilityApprovalCode)
        _.set(modelVM, 'locRisk.stoFacFie.value', object.approvedStorageFacilities)
        _.set(modelVM, 'locRisk.stoAddFie.value', object.address)
        _.set(modelVM, 'locRisk.stoCitFie.value', object.city)

        if (object.province != null) {
            const province = mapCodeToProvince(object.province)

            _.set(modelVM, 'locRisk.stoProvinceCode.value', province)
            _.set(modelVM, 'locRisk.stoProvince.value', object.province)
        }

        _.set(modelVM, 'locRisk.stoPosCodFie.value', object.postal)
        setStorageFacCodeSearchVisible(false);
        updateWizardData(submissionVM);
    }, [mapCodeToProvince, modelVM, submissionVM, updateWizardData]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (changedPath === 'locRisk.stoProvinceCode') {
                const province = mapCodeToProvince(value)

                _.set(submissionVM, 'locRisk.stoProvinceCode.value', province)
                _.set(submissionVM, `${pathUpdated}.locRisk.stoProvince`, value);
            } else {
                const fullPath = `${pathUpdated}.${changedPath}`;

                _.set(submissionVM, `${fullPath}`, value);
            }

            updateWizardData(submissionVM);
        },
        [mapCodeToProvince, pathUpdated, submissionVM, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        storageFacilityComponent: {
            data: modelVM.storageFacilityExpos,
            updateWizardData,
            submissionVM,
            storageFacPath: `${pathUpdated}.storageFacilityExpos`
        },
        stoFacSearchBtn: {
            onClick: () => { searchStorageFacilityCode(); },
            visible: false
        },
        storageFacAdapters: {
            visible: storageFacCodeSearchVisible,
            key: sfapprovalCode,
            onFetchData: loadData
        },
        storageFacSearchContainer: {
            visible: storageFacCodeSearchVisible
        },
        storageFacAllContainer: {
            visible: storageFacCodeSearchVisible
        },
        storageFacClearIconBtn: {
            onClick: () => { clearIndustryDescription(); },
            title: translator(messages.clearStorageFacility)
        },
        stoFacCancelBtn: {
            onClick: () => { cancelSearch(); }
        },
        stoFacResetBtn: {
            onClick: () => { clearSearchTexts(); }
        },
        storageFacSearchIconBtn: {
            onClick: () => { openSearchPanel(); },
            title: translator(messages.searchStorageFacility)
        },
        storageFacCodeSearchInput: {
            value: sfapprovalCode,
            onValueChange: updateSFapprovalCode
        },
        approvedStorageFacSearchInput: {
            value: approvedStorageFac,
            onValueChange: updateApprovedStorageFac
        },
        addressSearchInput: {
            value: stoFacAddress,
            onValueChange: updateStoFacAddress
        },
        citySearchInput: {
            value: stoFacCity,
            onValueChange: updateStoFacCity
        },
        provinceSearchInput: {
            value: stoFacProvince,
            onValueChange: updateStoFacProvince
        },
        postalCodeSearchInput: {
            value: stoFacPostal,
            onValueChange: updateStoFacPostal
        },
        searchResultHeader: {
            visible: storageFacCodeSearchVisible
        },
        aretheconstoinatraFie: {
            defaultValue: false
        },
        contentStoredInTrailerContainer: {
            visible: _.get(modelVM, 'aretheconstoinatraFie.value', false)
        },
        desofProCovFie: {
            defaultValue: 'Personal Property in a Storage unit'
        },
        ifOthLocNamFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        yeainBusFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        howiseacindunilocFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        desallsecinplaatthsitFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        namofOnsmanFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        facDetHeader: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        isbuifenandgatFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        aretheconstoinatraFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
        },
        isthetraownbythefafacFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
                && _.get(modelVM, 'aretheconstoinatraFie.value', true)
        },
        hasthehitbeeremFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
                && _.get(modelVM, 'aretheconstoinatraFie.value', true)
        },
        havthewhebeeremFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
                && _.get(modelVM, 'aretheconstoinatraFie.value', true)
        },
        isthetrainalocfenaareFie: {
            visible: _.get(modelVM, 'locRisk.stoFacFie.value') === 'Other'
                && _.get(modelVM, 'aretheconstoinatraFie.value', true)
        },
        sfstorageFacilityApprovalCode: {
            value: sfapprovalCode
        },
        emptyResultWarningMessage: {
            visible: emptyResultWarning
        },
        stoSfCode: {
            visible: !_.isUndefined(submissionVM.value.lobData.perLine.selectedOffering_Ext)
                && _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') !== 'PerProInSto'
        }

    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            onActionClick,
            onCell,
            renderSelectButton
        },
        resolveComponentMap: {
            storageFacilityComponent: StorageFacilityExp
        },
        resolveClassNameMap: styles
    };


    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PropertyDetailsComponent.propTypes = wizardProps;
export default withRouter(PropertyDetailsComponent);
